// components/HeroLanding.tsx
import React from "react";
import { Container, Image, Button } from "react-bootstrap";
import { HeroLanding as HeroLandingI } from "../../types/interfaces/HeroLanding";
import { HeroLandingCss } from "./HeroLandingCss";
import { useAuth } from "modules/auth/hooks";

import "./HeroLanding.styles.css";
import { SIGN_UP_URL } from "modules/auth/constants";

const HeroLanding = (hero: HeroLandingI) => {
  const { login } = useAuth();

  return (
    <div
      className="hero-landing-area"
      style={{
        backgroundImage: `url(${hero.backgroundImage})`
      }}
    >
      <Container style={{ zIndex: "2" }}>
        <div className="landing-hero-content text-center">
          <p>
            <Image
              src={hero.logoUrl}
              alt="STAIDIUM LOGO"
              className="landing-logo"
              width={"25%"}
            />
          </p>
          <br />
          <h1 className="title">{hero.mainHeading}</h1>
          <h4 className="sub-title">{hero.secondHeading}</h4>
          <p>{hero.text}</p>
          <div className="create-membership-wrap">
            <input placeholder="Email Address" required type="email" />
            <Button
              className="landing-btn-style"
              onClick={() => (window.location.href = SIGN_UP_URL.href)}
            >
              Get Started
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeroLanding;
